import { DatePicker, DatePickerModel } from '@syncfusion/ej2-calendars';
import { Popup } from '@syncfusion/ej2-popups';

import { YEAR_END_MAX_DATE, YEAR_END_MIN_DATE } from '@/shared/constants';
import { EditableClientProps } from '@/shared/types/editable';
import { datesEqual, shiftFromUtc } from '@/shared/utils/date';
import { dateInputFormat, formatDate } from '@/shared/utils/format';

import { controlModel } from '@/front/editable/control';
import { input } from '@/front/editable/input';
import { addValidation, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';

const DEFAULT_DATE_PICKER_WIDTH = 130;

export const initDatePicker = (p: EditableClientProps, e: HTMLElement) => {
  const datePicker = new DatePicker({
    ...datePickerModel(p),
    change: change(e),
  });

  datePicker.appendTo(input(p, e));

  setControl(p.id, datePicker);

  addValidation(p, e);
};

export const datePickerModel = (p: EditableClientProps): DatePickerModel & { value: Date | null } => {
  const allowManualEntry = p.allowManualEntry ?? true;

  let popup: Popup | undefined;

  return {
    ...controlModel(p),
    // @ts-expect-error we use null rather than undefined to represent no value in DB
    value: p.value ? shiftFromUtc(p.value) : null,
    min: p.minDate ? shiftFromUtc(p.minDate) : undefined,
    max: p.maxDate ? shiftFromUtc(p.maxDate) : undefined,
    allowEdit: allowManualEntry,
    format: p.format ?? dateInputFormat,
    placeholder: p.placeholder ?? formatDate(p.defaultValue as Date),
    showTodayButton: !(p.minDate || p.maxDate),
    showClearButton: false,
    ...(!p.fullwidth ? { width: DEFAULT_DATE_PICKER_WIDTH } : {}),
    openOnFocus: !allowManualEntry,
    open: (e) => {
      popup = e.popup as Popup;
      formatDatePickerPopupTitle(p, popup);
    },
    navigated: () => {
      formatDatePickerPopupTitle(p, popup);
    },
  };
};

const formatDatePickerPopupTitle = (p: EditableClientProps, popup?: Popup) => {
  if (popup) {
    const popupTitle = popup.element.firstElementChild?.firstElementChild?.firstElementChild;

    if (
      p.type === 'Date' &&
      popupTitle &&
      p.minDate &&
      datesEqual(shiftFromUtc(p.minDate), YEAR_END_MIN_DATE) &&
      p.maxDate &&
      datesEqual(shiftFromUtc(p.maxDate), YEAR_END_MAX_DATE)
    ) {
      popupTitle.innerHTML = popupTitle.innerHTML.replace('2000', '');
    }
  }
};
